// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__4ZeDb","label":"SetPasswdForm_label__ibSeV"};